import { useParams } from "react-router-dom";
import { Head } from "features/misc";
import { useProject } from "features/reviewable";
import { ProjectReviewForm } from "features/reviews";

function CreateProjectReview() {
  const { projectId } = useParams() as { projectId: string };
  const { data: project } = useProject(projectId);
  return (
    <>
      <Head title={`Review ${project?.name}`} />
      <ProjectReviewForm project={project} projectId={projectId} />
    </>
  );
}

export { CreateProjectReview };
